import React, { useContext } from "react";
import TaxSummaryMobile from "./TaxSummaryMobile";
import DeviceContext from "../../../../utils/indentifyDevice";
import ShowGainsMobile from "./ShowGainsMobile";
import TaxTableMobile from "./TaxTableMobile";
import CalendarPopupMob from "@frameworks/web/components/generic/Calendar/CalendarPopupMob";
import moment from "moment";
import FamilyTaggingMain from "@frameworks/web/components/Reports/FamilyTagging/FamilyTaggingReport/FamilyTaggingMain";
import { getFinancialYears } from "@domains/utils/reportDates";
import PopBodProcessBlock from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PopBodProcessBlock";
import TaxHarvestingBanner from "../TaxHarvestingBanner";
import { useNavigate } from "react-router-dom";
import { WebConfigContext } from "@frameworks/web/utils/webConfig";
const TaxReportMobile = (props) => {
    var _a, _b, _c, _d, _e;
    const navigate = useNavigate();
    const webConfig = useContext(WebConfigContext);
    const financialYears = getFinancialYears(props.startDate, props.endDate);
    DeviceContext().isMobile &&
        require("../../../../stylesheets/components/Reports/TAXReports/TaxReportMobile.scss");
    return (React.createElement("section", { id: "tax" },
        (webConfig === null || webConfig === void 0 ? void 0 : webConfig.isTaxHarvesting) && (React.createElement(TaxHarvestingBanner, { onClick: () => {
                let baseURL = "/taxDownload?fromDate=" +
                    moment(props.startDate).format("D-MMM-YY") +
                    "&toDate=" +
                    moment(props.endDate).format("D-MMM-YY") +
                    "&isTaxharvesting=true";
                let url = props.accCode
                    ? `${baseURL}&family=${window.btoa(props === null || props === void 0 ? void 0 : props.accCode)}`
                    : baseURL;
                navigate(url);
            } })),
        React.createElement("div", { className: "calendar_date justify-content-between align-items-center" },
            React.createElement("div", null,
                React.createElement("span", { className: "fin_year" }, financialYears.label),
                React.createElement("span", null,
                    "\u00A0(",
                    moment(props.startDate).format("D-MMM-YY"),
                    "\u00A0 to ",
                    moment(props.endDate).format("D-MMM-YY"),
                    ")"),
                " "),
            React.createElement("div", null,
                React.createElement("div", { className: "calendar_change" },
                    React.createElement("i", { className: "edel-icon-calendar2" }),
                    React.createElement("span", { onClick: () => {
                            props.setOpenCalendar(true);
                        } }, "\u00A0Change")))),
        !props.shimmer &&
            ((_b = (_a = props === null || props === void 0 ? void 0 : props.taxData) === null || _a === void 0 ? void 0 : _a.taxDataFlags) === null || _b === void 0 ? void 0 : _b.isBodEnabled) &&
            ((_d = (_c = props === null || props === void 0 ? void 0 : props.taxData) === null || _c === void 0 ? void 0 : _c.taxDetail) === null || _d === void 0 ? void 0 : _d.length) > 0 && (React.createElement(PopBodProcessBlock, { bodProcessInfoMessage: props.taxData.taxDataFlags.bodProcessInfoMessage })),
        React.createElement("div", { className: "pb-10" },
            React.createElement(FamilyTaggingMain, { oldTheme: true })),
        React.createElement("div", { className: "drawer_year_container secondary-navy-theme" },
            React.createElement(CalendarPopupMob, { openCalendar: props.openCalendar, setOpenCalendar: props.setOpenCalendar, startDate: props.startDate, endDate: props.endDate, finYear: props.finYear, setStartDate: props.setStartDate, setEndDate: props.setEndDate, setFinYear: props.setFinYear, customTime: true, setNextFinYear: props.setNextFinYear })),
        React.createElement("div", { className: "tax-summary" },
            React.createElement(TaxSummaryMobile, { taxSummaryData: props === null || props === void 0 ? void 0 : props.taxData, mainCompoentShimmer: props === null || props === void 0 ? void 0 : props.shimmer })),
        React.createElement(ShowGainsMobile, { emptyValidation: props.emptyValidation, taxReportError: props.taxReportError, shimmer: props.shimmer, finYear: props.finYear, fromDate: props.startDate, toDate: props.endDate, accCode: props === null || props === void 0 ? void 0 : props.accCode, openPopUp: props.openPopUp, setOpenPopup: props.setOpenPopup, isTaxHarvesting: props.isTaxHarvesting }),
        React.createElement(TaxTableMobile, { taxDetailsData: (_e = props.taxData) === null || _e === void 0 ? void 0 : _e.taxDetail, taxReportError: props.taxReportError, emptyValidation: props.emptyValidation, mainCompShimmer: props.shimmer })));
};
export default TaxReportMobile;
